

























































import { Component, Prop, Vue, Watch } from "vue-property-decorator";

import ResumeRanap from "@/pages/ResumeRanap.vue";
import PemeriksaanReadonlyBanner from "@/components/pemeriksaan/PemeriksaanReadonlyBanner.vue";

import EncounterIndexSvc from "@/services/EncounterIndex";
import EncounterIndexStore from "@/store/modules/EncounterIndex";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import SoapRanapStore from "@/store/modules/SoapRanapStore";
import revisionAccessModule from "@/store/modules/RevisionAccessStore";
import { storeDokter } from "@/store/modules/dokter";
import { storePasien } from "@/store/modules/pasien";
import { userModule } from "@/store/modules/user";
import { evaluatePemeriksaanReadOnly } from "@/utility/PemeriksaanReadonly";
import type { ActiveApproval } from "@/utility/PemeriksaanReadonly";
import { resetStorePasienRanap } from "@/utils/resetStorePasien";

@Component({
  components: {
    ResumeRanap,
    PemeriksaanReadonlyBanner
  },
  provide() {
    const self = this as {
      readOnly?: boolean;
      readOnlyDokumenPulang?: boolean;
    };

    return {
      isReadOnly: () => !!self.readOnly,
      isReadOnlyDokumenPulang: () => !!self.readOnlyDokumenPulang
    };
  }
})
export default class DialogResumeRanap extends Vue {
  @Prop({ type: Boolean, default: false }) readonly value!: boolean;
  @Prop({ required: true }) readonly register!: string;
  @Prop({ default: "" }) readonly rm!: string;

  ready = false;
  gagal = false;
  memuat = false;
  alasanGagal = "";

  get registerKunjungan() {
    return RegisterKunjungan.register;
  }

  get pasienLabel(): string {
    const reg: any = this.registerKunjungan;

    if (!reg) {
      return "";
    }

    return [this.rm, reg.pasien ? reg.pasien.nama : null]
      .filter(Boolean)
      .join(" — ");
  }

  get activeApproval(): ActiveApproval | null {
    const reg: any = this.registerKunjungan;
    const no = reg ? reg.no : null;

    if (!no) {
      return null;
    }

    const snap = revisionAccessModule.activeByRegister[no];

    if (!snap || !snap.has_active || !snap.active) {
      return null;
    }

    return {
      expiresAt: snap.active.expires_at,
      approvedAt: snap.active.approved_at,
      grantedMinutes: snap.active.granted_minutes
    };
  }

  get readOnlyResult() {
    return evaluatePemeriksaanReadOnly(
      this.registerKunjungan,
      new Date(),
      this.activeApproval,
      userModule.unitGate
    );
  }

  get readOnly(): boolean {
    return this.readOnlyResult.readOnly;
  }

  get readOnlyDokumenPulangResult() {
    return evaluatePemeriksaanReadOnly(
      this.registerKunjungan,
      new Date(),
      this.activeApproval,
      userModule.unitGate,
      { dokumenPulang: true }
    );
  }

  get readOnlyDokumenPulang(): boolean {
    return this.readOnlyDokumenPulangResult.readOnly;
  }

  @Watch("value")
  onToggle(val: boolean) {
    if (val) {
      this.muat();
    } else {
      this.bersihkan();
    }
  }

  async muat() {
    if (this.memuat || !this.register) {
      return;
    }

    this.memuat = true;
    this.ready = false;
    this.gagal = false;
    this.alasanGagal = "";

    resetStorePasienRanap();

    const reg = this.register;

    try {
      await EncounterIndexSvc.regRanap(reg, this.rm).catch(() => undefined);

      await Promise.all([
        RegisterKunjungan.getRegister(reg).catch(() => undefined),
        storePasien.act_pasien_last_reg(this.rm).catch(() => undefined),
        EncounterIndexStore.getEncounterRanap(reg).catch(() => undefined),
        SoapRanapStore.getByRegister(reg).catch(() => undefined)
      ]);

      if (!storeDokter.listAll.length) {
        await storeDokter.act_dokter_all().catch(() => undefined);
      }

      const kunjungan: any = RegisterKunjungan.register;

      if (!kunjungan) {
        this.alasanGagal = "Data register tidak dapat dimuat.";

        throw new Error("register tidak ditemukan");
      }

      if (!EncounterIndexStore.encRanap) {
        this.alasanGagal =
          "Register ini belum punya data episode rawat inap (encounter), sehingga form resume tidak dapat dibuka dari sini.";

        throw new Error("encounter ranap tidak ada");
      }

      const sudahPulang =
        !!kunjungan.discharge_at ||
        (!!kunjungan.dout && kunjungan.dout !== "0000-00-00");

      if (sudahPulang) {
        await revisionAccessModule
          .fetchActive(kunjungan.no)
          .catch(() => undefined);
      }

      if (String(reg) !== String(this.register) || !this.value) {
        return;
      }

      this.ready = true;
    } catch (e) {
      this.gagal = true;
    } finally {
      this.memuat = false;
    }
  }

  bersihkan() {
    this.ready = false;
    this.gagal = false;
    this.alasanGagal = "";

    resetStorePasienRanap();

    this.$emit("closed");
  }

  tutup() {
    this.$emit("input", false);
  }

  beforeDestroy() {
    if (this.ready) {
      resetStorePasienRanap();
    }
  }
}
